// Keys that must SURVIVE a sign-out.
//
// Everything else in localStorage is wiped when a user signs out, which is the
// right default: it is account data, and the next person at the same computer
// must not inherit it. But a handful of flags record "this browser has already
// been shown X" -- they belong to the browser, not the account, and wiping
// them makes a one-time message reappear on every single sign-in.
//
// That is exactly what happened to the 4.0 welcome popup: it stores
// `bidmii40WelcomeSeen`, sign-out called `localStorage.clear()`, and the popup
// came back every login while still promising "you'll only see this once".
const KEEP_ON_SIGN_OUT = ['bidmii40WelcomeSeen'];

/**
 * Clears browser storage on sign-out, preserving the keys above.
 *
 * Deliberately a keep-list rather than a delete-list: anything new that starts
 * getting written to localStorage is cleared automatically, so a future key
 * holding account data can never be left behind by omission. Only a key
 * explicitly named here survives.
 */
export const clearStorageOnSignOut = () => {
  const preserved: [string, string][] = [];
  KEEP_ON_SIGN_OUT.forEach((key) => {
    const value = localStorage.getItem(key);
    if (value !== null) {
      preserved.push([key, value]);
    }
  });

  sessionStorage.clear();
  localStorage.clear();

  preserved.forEach(([key, value]) => localStorage.setItem(key, value));
};

export default clearStorageOnSignOut;
